exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-header[data-v-02c906dc]{margin-top:15px;border-top:1px solid #d9e0e6;border-bottom:1px solid #d9e0e6}.tab-header[data-v-02c906dc],.table-header[data-v-02c906dc]{height:45px;line-height:45px;font-size:16px}.tab-header-text[data-v-02c906dc]{border-left:1px solid #d9e0e6;text-align:center;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-02c906dc","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/electronicMedicalRecord/patient/parts/dialysisInfo/dialysisRecords/index.vue
// module id = yjF0
// module chunks = 0